module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/cyclebar-14c91e7076bc86031e2d769c7af4bb20.png";